
import request from '@/utils/request'
/*
  大屏 权限操作api
*/

// 获取平台综合柜统计数量
export function getCabinetCountInfo(data) {
    return request({
        url: 'device-service/home/getCabinetCountInfo',
        method: 'get',
        params: data
    })
}

// 获取平台设备统计数量
export function getDeviceCountInfo(data) {
    return request({
        url: 'device-service/home/getDeviceCountInfo',
        method: 'get',
        params: data
    })
}

// 获取平台状态统计
export function getDeviceStatusInfo(data) {
    return request({
        url: 'device-service/home/getDeviceStatusInfo',
        method: 'get',
        params: data
    })
}

// 获取平台电池曲线
export function getBatteryCurve(data) {
    return request({
        url: 'device-service/home/getBatteryCurve',
        method: 'get',
        params: data
    })
}

// 获取平台电池信息
export function getBatteryInfo(data) {
    return request({
        url: 'device-service/home/getBatteryInfo',
        method: 'get',
        params: data
    })
}

// 获取平台故障数量统计
export function getDeviceAlarmInfo(data) {
    return request({
        url: 'device-service/home/getDeviceAlarmInfo',
        method: 'get',
        params: data
    })
}


// 获取平台电源曲线
export function getPowerCurve(data) {
    return request({
        url: 'device-service/home/getPowerCurve',
        method: 'get',
        params: data
    })
}

// 获取平台电源信息
export function getPowerInfo(data) {
    return request({
        url: 'device-service/home/getPowerInfo',
        method: 'get',
        params: data
    })
}

// 获取平台整流曲线
export function getRectifyCurve(data) {
    return request({
        url: 'device-service/home/getRectifyCurve',
        method: 'get',
        params: data
    })
}

// 获取平台整流信息
export function getRectifyInfo(data) {
    return request({
        url: 'device-service/home/getRectifyInfo',
        method: 'get',
        params: data
    })
}

// 获取平台温湿度曲线
export function getSensorCurve(data) {
    return request({
        url: 'device-service/home/getSensorCurve',
        method: 'get',
        params: data
    })
}

// 获取平台整流信息
export function getSensorInfo(data) {
    return request({
        url: 'device-service/home/getSensorInfo',
        method: 'get',
        params: data
    })
}
